import * as React from 'react';

function SvgEthChangeArrowUp(props) {
  return (
    <svg
      width={72.438}
      height={50}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M72.439 25L0 0l15.583 25L.002 50z" fill={props.color} />
    </svg>
  );
}

export default SvgEthChangeArrowUp;
